




























































import Vue from 'vue'
import { CastTemplate } from '@/types/casttemplates'
import { Table, TableColumn } from 'element-ui'
import { Scene } from '@/types/scenes'
import { Stream } from '@/types/streams'
import { UserProfile } from '@/types/users'
import { AssetGroup } from '@/types/assets'
import { KeyDict } from '@/types'
import './CastTemplateDetails.scss'

interface Caster {
  name: string
}

export default Vue.extend({
  props: {
    template: {
      type: Object as () => CastTemplate,
    },
    teamStreams: {
      type: Object as () => KeyDict<Stream>
    },
    currentTeam: {
      type: Array as () => UserProfile[]
    },
    folderList: {
      type: Array as () => AssetGroup[]
    }
  },
  computed: {
    scenes (): Scene[] {
      const scenes: Scene[] = []
      Object.keys(this.template.scenes).forEach(key => {
        scenes.push(this.template.scenes[key])
      })
      return scenes
    },
    inputs (): Stream[] {
      const inputs: Stream[] = []
      Object.keys(this.template.input_streams).forEach(key => {
        inputs.push(this.teamStreams[key])
      })
      return inputs
    },
    outputs (): {name: string, srcurl: string}[] {
      const outputs: {name: string, srcurl: string}[] = []
      if (this.template.custom_rtmp_destinations !== undefined) {
        Object.keys(this.template.custom_rtmp_destinations).forEach(key => {
          if (this.template.custom_rtmp_destinations[key].type === 'url') {
            outputs.push({ name: 'Manual URL', srcurl: this.template.custom_rtmp_destinations[key].url })
          } else {
            if (this.teamStreams[key] !== undefined) {
              outputs.push({ name: this.teamStreams[key].name, srcurl: this.teamStreams[key].srcurl })
            }
          }
        })
      }
      return outputs
    },
    casters (): Caster[] {
      const casters: Caster[] = []
      Object.keys(this.template.invited_casters).forEach(key => {
        const member = this.currentTeam.find(member => member.id === key)
        if (member !== undefined) {
          casters.push({ name: member.first_name + ' ' + member.last_name })
        }
      })
      return casters
    },
    folders (): AssetGroup[] {
      const folders: AssetGroup[] = []
      Object.keys(this.template.asset_groups).forEach(key => {
        const folder = this.folderList.find(folder => folder.id === key)
        if (folder !== undefined) {
          folders.push(folder)
        }
      })
      return folders
    }
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn
  }
})
